const defaultDateTimeOptions = {
    default: {
        // Dec 19, 2020, 7:23 PM
        dateStyle: "medium",
        timeStyle: "short",
    },
};
export { defaultDateTimeOptions };
